import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CruiseHighlights from "./Highlights";
import Renderads from "./advertisement";

const RenderCarRentals = () => {
  const [pickupFrom, setPickupFrom] = useState("");
  const [dropLocation, setDropLocation] = useState("");
  const [pickupDate, setPickupDate] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!pickupFrom.trim() || !dropLocation.trim() || !pickupDate.trim()) {
      alert("Please fill all required fields.");
      return;
    }

    navigate("/cruises");
  };

  return (
    <div className="pb-20">
      <Renderads imgNumber={1} />

      {/* Premium Container */}
      <div className="bg-white/90 backdrop-blur-xl border border-gray-200 p-8 rounded-3xl shadow-lg max-w-6xl mx-auto mt-10">

        {/* Header */}
        <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-5 text-center">
          🚗 Find the Best Car Rentals
        </h2>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">

            <div>
              <label className="text-xs text-gray-600 font-semibold mb-1 block">
                Pickup From
              </label>
              <input
                type="text"
                value={pickupFrom}
                onChange={(e) => setPickupFrom(e.target.value)}
                className="border border-gray-300 rounded-xl px-4 py-3 w-full bg-white focus:ring-2 focus:ring-blue-500 transition text-gray-800"
                placeholder="Enter pickup location"
                required
              />
            </div>

            <div>
              <label className="text-xs text-gray-600 font-semibold mb-1 block">
                Drop Location
              </label>
              <input
                type="text"
                value={dropLocation}
                onChange={(e) => setDropLocation(e.target.value)}
                className="border border-gray-300 rounded-xl px-4 py-3 w-full bg-white focus:ring-2 focus:ring-blue-500 transition text-gray-800"
                placeholder="Enter drop location"
                required
              />
            </div>

            <div>
              <label className="text-xs text-gray-600 font-semibold mb-1 block">
                Pickup Date
              </label>
              <input
                type="date"
                value={pickupDate}
                onChange={(e) => setPickupDate(e.target.value)}
                className="border border-gray-300 rounded-xl px-4 py-3 w-full bg-white focus:ring-2 focus:ring-blue-500 transition text-gray-800"
                required
              />
            </div>
          </div>

          {/* Button */}
          <div className="mt-6 flex justify-center">
            <button
              type="submit"
              className="
                bg-gradient-to-r from-blue-600 to-blue-700 
                hover:from-blue-700 hover:to-blue-800 
                text-white font-semibold 
                px-10 py-3 rounded-full shadow-md 
                transition-all transform hover:scale-105
              "
            >
              Search
            </button>
          </div>
        </form>
      </div>

      {/* Highlights */}
      <div className="mt-16">
        <CruiseHighlights />
      </div>
    </div>
  );
};

export default RenderCarRentals;
